import { faArrowLeft } from "@fortawesome/pro-regular-svg-icons/faArrowLeft";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

export const ButtonPreviousStep: React.FC<MprcButtonProps> = ({ text, title, color = "primary", variant = "contained", ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = text || theme.buttons.ButtonPreviousStep.text;
    const lTitle = title || theme.buttons.ButtonPreviousStep.title;

    return (
        <MprcButton
            {...rest}
            color={color}
            variant={variant}
            title={lTitle}
            text={lText}
            startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
        />
    );
};
